/**
 * Matches the `max-width: 768px` breakpoint used by the mobile/desktop view switches.
 */
export const MOBILE_BREAKPOINT = '(max-width: 768px)';
